import {
  AfterContentChecked,
  Directive,
  effect,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import { PAGES_WITHOUT_TRANSLATION } from '@core/api/constants/not-translated-pages.constants';
import { DEFAULT_LANG } from '@translate/constants/available-langs';
import { LanguageService } from '@translate/services/language.service';

@Directive({
  selector: '[nodaHref]',
  standalone: true,
})
export class NodaHrefDirective implements AfterContentChecked {
  @Input('nodaHref') public href: string;
  @Input('nodaHrefLang') public hrefLang: string;

  constructor(
    private languageService: LanguageService,
    private renderer: Renderer2,
    private elRef: ElementRef,
  ) {
    effect(() => this.updateHref());
  }

  ngAfterContentChecked(): void {
    this.updateHref();
  }

  private createUrl(lang: string): string {
    if (!lang) {
      return this.href;
    } else {
      return `/${lang}${this.href}`;
    }
  }

  private setHref(lang?: string): void {
    this.renderer.setAttribute(this.elRef.nativeElement, 'href', this.createUrl(lang));
  }

  private isMailTo(): boolean {
    return this.href.includes('mailto');
  }

  private updateHref(): void {
    if (!this.href) {
      return;
    }
    if (this.isMailTo()) {
      this.setHref();

      return;
    }
    if (this.hrefLang) {
      this.setHref(this.hrefLang);

      return;
    }

    const activatedLang: string = this.languageService.langSignal();
    const isForeignLink: boolean = this.href?.match(/https?:\/\//)?.length > 0;
    const isLinkHasLangPrefix: boolean = this.href?.startsWith(`/${activatedLang}`);
    const isPageTranslated: boolean = !PAGES_WITHOUT_TRANSLATION.find((page: string) =>
      this.href.includes(page),
    );

    const needsModification: boolean =
      !isForeignLink && !isLinkHasLangPrefix && activatedLang !== DEFAULT_LANG && isPageTranslated;

    if (needsModification) {
      this.setHref(activatedLang);
    } else {
      this.setHref();
    }
  }
}
